export default __webpack_public_path__ + "static/media/Punto_08_Piazza_della_Repubblica_ITA_Def.66a202cc.aac";